export const WORKPLACE_TYPES = [
  "Apartment Complex",
  "Factory",
  "Gym",
  "Laundromat",
  "Medical Centre",
  "Office",
  "Other",
];
